import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { useIpCheck } from 'hooks/api/useIpCheck'

// import './css/botIpCheck.css'
import { useTgWebApp } from 'lib/tgWebApp/useTgWebApp'

import './css/botIpCheck.css'

export const YBotIpCheck = () => {
  const { isIpCheckReady, isAllowed } = useIpCheck()
  const { action }=useParams()

  // --- Web-app integration ------------------------
  const { closeWebApp} = useTgWebApp()
  useEffect(() => {
    if (isIpCheckReady) closeWebApp(`${action}-ip-${isAllowed ? 'allowed' : 'restricted'}`)
  }, [closeWebApp, action, isIpCheckReady, isAllowed])
  /// ---------------------------

  return (
    <>
      {/* <Helmet>
        <title>AXE CAP • IP Check</title>
      </Helmet> */}
      	<div id="ip_check_page_wrapper">
		<div id="main">
			<div className="content">
            <div className="yolobot_logo" style={{
  background: "url('/images/yolobot_logo_2.svg') center center / auto auto no-repeat",
          
        }}></div>
				<div className="project_tagline">
					Verifying your IP address...
				</div>
			</div>
		</div>
	</div>
    </>
  )
}

